import './viewSelector.less'

import React from "react"
import {observer} from "mobx-react"
import {Divider, Typography} from "antd"
import {EditOutlined, PlusOutlined, ReloadOutlined} from "@ant-design/icons"
import {AntSelect} from "controls/react/ant/antSelect"
import {linkModel} from "framework/mobx-integration"
import {Section} from 'controls/react/layout/section'
import {AntButton} from 'controls/react/ant/antButton'
import {GridDataEntry} from "controls/grid/gridDataEntry"
import {ViewManagerStore} from "controls/grid/viewManager/viewManagerStore";
import {SaveViewButton, ViewManager} from "controls/grid/viewManager/viewManager";
import {AntModal, ModalPosition} from "controls/react/ant/antModal";
import {useStore} from "core/react/useStore";
import {GridViewSelectorProps} from "controls/grid/viewManager/gridViewSelectorProps";


const i = require('core/localization/localization').translator({
	'Add View': {no: 'Legg visning'},
	'Open view settings': {no: 'Ãpne visning innstillinger'},
	'Reset to Defaults': {no: 'Tilbakestill'},
	'Select View...': {
		en: 'Select view...',
		no: 'Velg visning...',
	},
});

const b = require('b_').with('grid-view-selector')
export const ViewSelector = observer(<T extends GridDataEntry, >(props: GridViewSelectorProps<T>) => {
	const store = useStore(() => new ViewManagerStore<T>(), {
		props: props
	})

	const dropdownRender = React.useCallback((menu: React.ReactElement) => {
		return <>
			{menu}

			{props.createViewDisabled !== true && <>
				<Divider className={b('divider')}/>

				<Typography.Link className={b('add-button')} onClick={store?.addView}>
					<PlusOutlined/> {i('Add View')}
				</Typography.Link>
			</>}
		</>
	}, [props.createViewDisabled, store?.addView])

	if(store.gridStore?.selfInitialized != true || !store.gridStore?.state)
		return null

	const gridStore = store.gridStore;

	return <Section appearance={"none"} direction={"row"} containerClass={b()}>
		<AntSelect dataList={store.gridStore.state.views}
		           placeholder={i('Select View...')}
		           className={b('views-list')}
		           size={"small"}
		           {...linkModel(store.gridStore.state, "currentViewId")}
		           nameField={'nameEffective'}
		           dropdownRender={dropdownRender}/>
				<AntButton icon={<EditOutlined/>}
				           onClick={store.toggleDetails}
						   size={"small"}
						   title={i('Open view settings')}/>

			<SaveViewButton store={store} size={"small"}/>
		<AntButton icon={<ReloadOutlined/>}
		           size={"small"}
		           title={i('Reset to Defaults')}
		           disabled={!gridStore.state.currentView.isDirty && !gridStore.state.currentView.isDefault()}
		           onClick={() => gridStore.state.reset(gridStore)}/>

		{store.showDetails &&
			<AntModal width={900}
			          height={400}
			          resizable={true}
			          positionType={ModalPosition.Mouse}
			          open={true}
			          footer={null}
			          closeOn={'clickOutside'}
			          onCancel={store.closeDetails}>
				<ViewManager store={store}/>
			</AntModal>
		}
	</Section>
})
